module.exports = __webpack_public_path__ + "img/icon17.ddf106a5.png";